import React, { FunctionComponent, useRef } from 'react';
import { styled } from '@mui/material/styles';
import { auth as firebaseAuth } from '../../config/firebase';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';

const StyledBlock = styled('pre')(({ theme}) => ({
  fontFamily: 'Inconsolata, "Andale Mono", Andale, monowidth',
  padding: '10px',
  margin: 0,
  borderRadius: '0 0 2px 2px',
  border: '1px solid #dfdfdf',
  maxWidth: '400px',
  overflowX: 'auto',
  backgroundColor: '#ecf0f1',
  color: '#c0392b',
  position: 'relative',
  minHeight: '200px',
  maxHeight: '300px'
}));

type CodeBlockProps = {
  children: React.ReactNode;
}

const CodeBlock: FunctionComponent<CodeBlockProps> = ({ children }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(children as string);
  }

  return (
    <StyledBlock>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="Exit"
        onClick={handleCopy}
        sx={{
          position: 'absolute',
          right: '5px',
          top: '5px',
          color: '#8d8c8c'
        }}
      >
        <ContentCopyIcon />
      </IconButton>
      {/*<code >*/}
        {children}
      {/*</code>*/}
    </StyledBlock>
  );
};

export default CodeBlock;
